// storage 存储规范化KEY
export * from './common/storage'
export * from './common/page-args'
// logs 日志流程输出
export * from './common/logs'
// whiteList 白名单路由（操作前检查）
export * from './common/white-list'
// 行为验证码
export * from './common/captcha'

// 用户
export * from './auth'

// 日期格式
export * from './common/date'

import { Toast } from 'mint-ui'
export const toast = message => {
  // 消息默认弹窗位置
  Toast({ message, position: 'middle' })
}

// vconsole 上打印日志
const vclog = { time: 0, current: {}, queue: [] }
export function vconsole_log() {
  const args = arguments
  vclog.queue.push(() => {
    console.log.apply(this, args)
  })
  if (vclog.time === 0) {
    vclog.time = setTimeout(() => {
      while ((vclog.current = vclog.queue.shift())) {
        vclog.current()
      }
      vclog.time = 0
    }, 1000)
  }
}

/**
 * 节流函数
 * @param {Function} func
 * @param {number} wait
 * @param {Object} options
 * @return {*}
 */
export function throttle(func, wait, options) {
  /* options的默认值
   *  表示首次调用返回值方法时，会马上调用func；否则仅会记录当前时刻，当第二次调用的时间间隔超过wait时，才调用func。
   *  options.leading = true;
   * 表示当调用方法时，未到达wait指定的时间间隔，则启动计时器延迟调用func函数，若后续在既未达到wait指定的时间间隔和func函数又未被调用的情况下调用返回值方法，则被调用请求将被丢弃。
   *  options.trailing = true;
   * 注意：当options.trailing = false时，效果与上面的简单实现效果相同
   */
  var context, args, result
  var timeout = null
  var previous = 0
  if (!options) options = {}
  var later = function () {
    previous = options.leading === false ? 0 : new Date()
    timeout = null
    result = func.apply(context, args)
    if (!timeout) context = args = null
  }
  return function () {
    var now = new Date()
    if (!previous && options.leading === false) previous = now
    // 计算剩余时间
    var remaining = wait - (now - previous)
    context = this
    args = arguments
    // 当到达wait指定的时间间隔，则调用func函数
    // 精彩之处：按理来说remaining <= 0已经足够证明已经到达wait的时间间隔，但这里还考虑到假如客户端修改了系统时间则马上执行func函数。
    if (remaining <= 0 || remaining > wait) {
      // 由于setTimeout存在最小时间精度问题，因此会存在到达wait的时间间隔，但之前设置的setTimeout操作还没被执行，因此为保险起见，这里先清理setTimeout操作
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)
      if (!timeout) context = args = null
    } else if (!timeout && options.trailing !== false) {
      // options.trailing=true时，延时执行func函数
      timeout = setTimeout(later, remaining)
    }
    return result
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * 转换为浮点数
 */
export function toFixedFloat(number, fractionDigits) {
  if (typeof number === 'string') {
    number = parseFloat(number)
  }
  number = number.toFixed(fractionDigits)
  // number = parseFloat(number)
  return number
}

/**
 * 商品类型枚举
 */
export function goodTypeStr(goodType) {
  if (!goodType) return ''
  let str = ''
  switch (goodType + '') {
    case '20001':
      str = '专辑'
      break
    case '30001':
      str = '套餐商品'
      break
    case '40001':
      str = '体验营'
      break
    case '40002':
      str = '训练营'
      break
    case '50001':
      str = 'vip会员'
      break
    case '60001':
      str = '礼品卡'
      break
    case '90001':
      str = '实物'
      break
    default:
      str = goodType
      break
  }
  return str
}
/**
 * 压缩图片,添加水印
 * @param {base64} originalImage 转换为 base64 的原始图片
 * @param {Number} compressRatio 压缩比例 0 - 1, 1则不压缩
 * @param {Number} custom 是否添加水印
 * @param {String} customText 水印文案
 * @param {Function} callback 回调方法, 执行回调后返回 base64 格式图片
 */
export const compressImg = (originalImage, compressRatio = 1, custom, customText, callback) => {
  const image = new Image()
  image.src = originalImage

  /* 监听图片的load事件 */
  image.addEventListener('load', function () {
    let [sizeRatio, maxWidth, maxHeight] = [0, 1024, 1024] // 图片压缩宽高比例和最大宽高
    const [imageWidth, imageHeight] = [this.naturalWidth, this.naturalHeight] // 图片实际宽高
    let compressFlag = false // 图片是否需要压缩

    // 如果图片宽度大于最大宽度就等比压缩图片的高度
    if (imageWidth > maxWidth) {
      compressFlag = true
      sizeRatio = imageWidth / maxWidth
      maxHeight = imageHeight / sizeRatio
    }

    // 如果图片高度大于最大高度就等比压缩图片的宽度
    if (imageHeight > maxHeight) {
      compressFlag = true
      sizeRatio = imageHeight / maxHeight
      maxWidth = imageWidth / sizeRatio
    }

    // 如果不需要压缩
    if (!compressFlag) {
      maxWidth = imageWidth
      maxHeight = imageHeight
    }

    // 使用canvas压缩图片
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    canvas.setAttribute('id', 'canvas')
    canvas.width = maxWidth
    canvas.height = maxHeight
    ctx.clearRect(0, 0, maxWidth, maxHeight) // 清除画布内所有像素
    ctx.drawImage(image, 0, 0, maxWidth, maxHeight) // canvas绘制当前图片
    if (custom) {
      let rate = (maxWidth * 0.06).toFixed(0)
      console.log(maxWidth, rate)
      rate = rate > 40 ? 46 : rate
      ctx.font = `${rate}px 微软雅黑`
      ctx.strokeStyle = 'rgba(153,153,153,0.3)'
      ctx.strokeText(customText, 9, 130)
      ctx.fillStyle = 'rgba(255,255,255,0.3)'
      ctx.fillText(customText, 9, 130)
    }
    const compressImage = canvas.toDataURL('image/jpeg', compressRatio) // 设置压缩类型和压缩比例获取压缩后的文件, 为 base64

    callback && callback(compressImage)
  })
}
export const base64ToBlob = function ({ b64data = '', contentType = '', sliceSize = 512 } = {}) {
  return new Promise((resolve, reject) => {
    // 使用 atob() 方法将数据解码
    const byteCharacters = atob(b64data)
    const byteArrays = []
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)
      const byteNumbers = []
      for (let i = 0; i < slice.length; i++) {
        byteNumbers.push(slice.charCodeAt(i))
      }
      // 8 位无符号整数值的类型化数组。内容将初始化为 0。
      // 如果无法分配请求数目的字节，则将引发异常。
      byteArrays.push(new Uint8Array(byteNumbers))
    }
    let result = new Blob(byteArrays, {
      type: contentType
    })
    const random = Math.random().toString().split('.')[1]
    result = Object.assign(result, {
      // 这里一定要处理一下 URL.createObjectURL

      preview: URL.createObjectURL(result),
      name: `${random}.png`
    })
    resolve(result)
  })
} // js精度
export function formatFloat(f, digit = 2) {
  var m = Math.pow(10, digit)
  // @ts-ignore
  return Math.round(f * m, 10) / m
}

/**
 * H5 DES 加密
 * @param {string} plaintext 待加密字符串
 * @param {string} key 密钥
 */
export function encryptDES_H5(plaintext, key) {
  const CryptoJS = require('crypto-js')

  var keyHex = CryptoJS.enc.Utf8.parse(key)

  var encrypted = CryptoJS.DES.encrypt(plaintext, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })

  // hex → binary → base64（与 decryptDES_H5 的 base64 → binary → hex 逆过程）
  var ciphertextHex = encrypted.ciphertext.toString()
  var binaryStr = ''
  for (var i = 0; i < ciphertextHex.length; i += 2) {
    binaryStr += String.fromCharCode(parseInt(ciphertextHex.substr(i, 2), 16))
  }
  return btoa(binaryStr)
}

/**
 * H5 DES 解码
 * @param {base64 加密的字符串} base64Ciphertext
 * @param {*} key
 */
export function decryptDES_H5(base64Ciphertext, key = getRequestKey()) {
  // 引入 crypto-js
  const CryptoJS = require('crypto-js')

  var keyHex = CryptoJS.enc.Utf8.parse(key)

  // H5 使用 atob 解码 base64，然后转换为 hex
  var binaryString = atob(base64Ciphertext)
  var hexStr = ''
  for (var i = 0; i < binaryString.length; i++) {
    var hex = binaryString.charCodeAt(i).toString(16)
    hexStr += hex.length === 2 ? hex : '0' + hex
  }

  var decrypted = CryptoJS.DES.decrypt({
      ciphertext: CryptoJS.enc.Hex.parse(hexStr)
    },
    keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  )

  var result_value = decrypted.toString(CryptoJS.enc.Utf8)
  return result_value
}

/**
 * H5 AES-ECB 加密
 * @param {string} plaintext 待加密字符串
 * @param {string} key 密钥
 */
export function encryptAES_H5(plaintext, key = getRequestKey()) {
  if (!plaintext) return plaintext
  const CryptoJS = require('crypto-js')

  var keyHex = CryptoJS.enc.Utf8.parse(key)

  var encrypted = CryptoJS.AES.encrypt(plaintext, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })

  // hex → binary → base64
  var ciphertextHex = encrypted.ciphertext.toString()
  var binaryStr = ''
  for (var i = 0; i < ciphertextHex.length; i += 2) {
    binaryStr += String.fromCharCode(parseInt(ciphertextHex.substr(i, 2), 16))
  }
  return btoa(binaryStr)
}

/**
 * H5 AES-ECB 解密
 * @param {string} base64Ciphertext Base64 密文
 * @param {string} key 密钥
 */
export function decryptAES_H5(base64Ciphertext, key = getRequestKey()) {
  const CryptoJS = require('crypto-js')

  var keyHex = CryptoJS.enc.Utf8.parse(key)

  // base64 → binary → hex
  var binaryString = atob(base64Ciphertext)
  var hexStr = ''
  for (var i = 0; i < binaryString.length; i++) {
    var hex = binaryString.charCodeAt(i).toString(16)
    hexStr += hex.length === 2 ? hex : '0' + hex
  }

  var decrypted = CryptoJS.AES.decrypt({
      ciphertext: CryptoJS.enc.Hex.parse(hexStr)
    },
    keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  )

  return decrypted.toString(CryptoJS.enc.Utf8)
}

/**
 * 获取加密密钥（混淆处理）
 */
export function getRequestKey() {
  const codes = [73, 58, 95, 73, 84, 82, 81, 67, 85, 36, 66, 84, 73, 72, 50, 54]
  return codes.map(c => String.fromCharCode(c - 1)).join('')
}
